// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__3oQa0","header":"Auth_header__2Fg91","errorMsg":"Auth_errorMsg__3xPmF","submitBtn":"Auth_submitBtn__3Jqoq"};